import { FETCH_COUNTRIES_SUCCESS, FETCH_PROVINCES_SUCCESS, FETCH_ALL_PROVINCES_SUCCESS } from '../constants/ActionTypes';

export default function countries(state = undefined, action) {
    switch (action.type) {
        case FETCH_COUNTRIES_SUCCESS:
            if (action.payload) {
                return action.payload.reduce((countriesMap, nextCountry) => {
                    const code = nextCountry.countryCode;
                    return {
                        ...countriesMap,
                        [code]: {
                            ...(state ? state[code] : {}),
                            ...nextCountry,
                        },
                    };
                }, {});
            }
            return state;

        case FETCH_ALL_PROVINCES_SUCCESS:
        case FETCH_PROVINCES_SUCCESS:
            if (action.payload) {
                return {
                    ...state,
                    ...action.payload.reduce((accumulator, next) => {
                        const { code, dataType, data } = next;
                        const hasProvinces = dataType?.toLowerCase() === 'province';
                        return {
                            ...accumulator,
                            ...(hasProvinces
                                ? {
                                      [code]: {
                                          ...(state ? state[code] : {}),
                                          provincesType: dataType,
                                          provinces: data.sort((a, b) => a.name.localeCompare(b.name)),
                                      },
                                  }
                                : {}),
                        };
                    }, {}),
                };
            }
            return state;

        default:
            return state;
    }
}
